export default {
    statisticDashboardCsak: [],
    emissionsDataTable: [],
    emissionsStatuses: [],
}
